/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import Member from "components/myteam/Member";
import { Trans } from "react-i18next";

class MembersTable extends Component {
  state = {
    sort_by: "trName", // training name by default
    sort_dir: "desc",
  };

  trName = "";
  trPosition = "";
  trQualifications = "";
  trFutureQualifications = "";
  trJoinedDate = "";
  trELearningCompletionRate = "";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.trName = "";
    this.trPosition = "";
    this.trQualifications = "";
    this.trFutureQualifications = "";
    this.trJoinedDate = "";
    this.trELearningCompletionRate = "";


    switch (this.state.sort_by) {
      case "trName":
        this.trName = `_${this.state.sort_dir}`;
        break;
      case "trPosition":
        this.trPosition = `_${this.state.sort_dir}`;
        break;
      case "trQualifications":
        this.trQualifications = `_${this.state.sort_dir}`;
        break;
      case "trFutureQualifications":
        this.trFutureQualifications = `_${this.state.sort_dir}`;
        break;
      case "trELearningCompletionRate":
        this.trELearningCompletionRate = `_${this.state.sort_dir}`;
        break;
      case "trJoinedDate":
        this.trJoinedDate = `_${this.state.sort_dir}`;
        break;
      default:
        this.trName = `_${this.state.sort_dir}`;
        break;
    }
  };

  renderData = () => {
    const sorted = this.props.data.sort((a, b) => {
      switch (this.state.sort_by) {
        case "trName":
          return this.state.sort_dir === "desc"
            ? a.fullname.localeCompare(b.fullname)
            : b.fullname.localeCompare(a.fullname);
        case "trPosition":
          return this.state.sort_dir === "desc"
            ? a.position?.name.localeCompare(b.position?.name)
            : b.position?.name.localeCompare(a.position?.name);
        case "trQualifications":
          return this.state.sort_dir === "desc"
            ? a.qualifications - b.qualifications
            : b.qualifications - a.qualifications;
        case "trFutureQualifications":
          return this.state.sort_dir === "desc"
            ? a.futureQualifications - b.futureQualifications
            : b.futureQualifications - a.futureQualifications;
        case "trELearningCompletionRate":
          return this.state.sort_dir === "desc"
            ? a.eLearningCompletionRate - b.eLearningCompletionRate
            : b.eLearningCompletionRate - a.eLearningCompletionRate;
        case "trJoinedDate":
          return this.state.sort_dir === "desc"
            ? new Date(a.workJoin) - new Date(b.workJoin)
            : new Date(b.workJoin) - new Date(a.workJoin);
        default:
          return this.state.sort_dir === "desc"
            ? a.fullname.localeCompare(b.fullname)
            : b.fullname.localeCompare(a.fullname);
      }
    });

    return sorted.map((m) => {
      return <Member key={m.fullname} mem={m} />;
    });
  };

  render() {
    this.setSotingClassNames();
    return (
      <div
        className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
        id="kayitliEgitimler"
        style={{ display: "block" }}
      >
        <table
          className="table display responsive dataTable no-footer dtr-none collapsed"
          id="dataTablePersonel"
        >
          <thead>
            <tr>
              <th
                onClick={() => this.reOrder("trName")}
                className={`all sorting${this.trName}`}
              >
                <div className="tableTitle">
                  <Trans desc="Ad Soyad">10063</Trans>
                </div>
              </th>
              <DesktopBreakpoint>
                <th
                  onClick={() => this.reOrder("trPosition")}
                  className={`desktop sorting${this.trPosition}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Pozisyon">10064</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trQualifications")}
                  className={`desktop sorting${this.trQualifications}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Mevcut Yeterlilik">10065</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trFutureQualifications")}
                  className={`desktop sorting${this.trFutureQualifications}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Gelecek Yeterlilik">10066</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trELearningCompletionRate")}
                  className={`desktop sorting${this.trELearningCompletionRate}`}
                >
                  <div className="tableTitle">
                    <Trans desc="E-öğrenme Tamamlama Oranı">10557</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trJoinedDate")}
                  className={`desktop sorting${this.trJoinedDate}`}
                >
                  <div className="tableTitle">
                    <Trans desc="İşe Giriş Tarihi">10067</Trans>
                  </div>
                </th>
              </DesktopBreakpoint>
            </tr>
          </thead>
          <tbody>
            {this.renderData()}
          </tbody>
        </table>
      </div>
    );
  }
}

export default MembersTable;
